import React, { useContext } from 'react';

import { PetArrangementsContext } from '../../context';

import { ArrangementsDisplay } from './arrangements-display';
import { ModalFormHeader } from './modal-form-header';
import { NoAssetsDisplay } from './no-assets-display';

export function WillPetArrangements() {
  const { arrangements } = useContext(PetArrangementsContext);
    
  return (
    <div className="form-container">
      <ModalFormHeader
        icon="pets"
        header="Pet Arrangements"
      />
      { arrangements.length > 0 ? (
        <ArrangementsDisplay pets={arrangements} />
      ) : (
        <NoAssetsDisplay 
          compact
          icon="info" 
          title="No Pets" 
          description="Add your pets and their arrangements." />
      )}
    </div>
  );
}